import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";

export function LegalLayout({ title, testid, children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <PublicHeader />
      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-20" data-testid={testid}>
        <h1 className="font-display text-4xl font-bold tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">DealsOps — a product of SAG LLC</p>
        <p className="text-sm text-muted-foreground">Effective date: September 20, 2026</p>
        <p className="text-sm text-muted-foreground" data-testid="legal-last-updated">Last updated: September 20, 2026</p>
        <div className="mt-8 space-y-4">{children}</div>
      </article>
      <PublicFooter />
    </div>
  );
}

export const LegalP = ({ children }) => (
  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">{children}</p>
);

export const LegalH = ({ children }) => (
  <h2 className="font-display text-xl font-semibold tracking-tight text-foreground pt-6">{children}</h2>
);

export const LegalList = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-sm sm:text-base text-muted-foreground leading-relaxed">
    {items.map((it) => <li key={String(it).slice(0, 40)}>{it}</li>)}
  </ul>
);

export const LegalA = ({ href, children }) => (
  <a href={href} className="text-amber-500 hover:underline">{children}</a>
);
